import connect from 'components/Shared/connect';
import { BrandsPageModel } from 'models/BrandsPageModel';
import { Main, Section } from 'components/Shared/Layout';
import { chunks } from 'utils';
import styles from './styles.scss';
import { BrandLink } from './brandLink';
import React from 'react';
import cn from 'classnames';

const AMOUNT_OF_COLUMNS = 4;

type MergedProps = Pick<BrandsPageModel, 'brands'>;

class BrandsPage extends React.Component<MergedProps, { currentAnchor?: string }> {
  public state = {
    currentAnchor: undefined
  };
  public render() {
    const { brands } = this.props;
    return (
      <Main>
        <Section>
          <nav className={styles.brandNavigation}>
            {Object.keys(brands).map(key => (
              <a
                onClick={this.setCurrentAnchor(key)}
                className={styles.brandNavigationLink}
                key={key}
                href={`#${key}`}
              >
                {key.toUpperCase()}
              </a>
            ))}
          </nav>
          {Object.keys(brands).map(key => {
            const size = brands[key].length / AMOUNT_OF_COLUMNS;
            const brandChunks = chunks(brands[key], Math.ceil(size));
            return (
              <div
                key={key}
                className={cn(styles.brandSectionContainer, {
                  [styles.currentAnchor]: this.state.currentAnchor === key
                })}
              >
                <h2 className={styles.brandLetter}>
                  <a id={key} className={styles.anchor}>
                    {key.toUpperCase()}
                  </a>
                </h2>
                <div className={styles.brandsContainer}>
                  {brandChunks.map((brands, i) => (
                    <div className={styles.brandsColumn} key={i}>
                      {brands.map(brand => (
                        <BrandLink key={brand.title} {...brand} />
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </Section>
      </Main>
    );
  }

  private setCurrentAnchor = (key: string) => () => this.setState({ currentAnchor: key });
}

export default connect<MergedProps>(state => {
  return {
    brands: (state.currentPage as BrandsPageModel).brands
  };
})(BrandsPage);
